<!-- todo 仅用于数字控件 0 返回空 &千分位格式化，目前仅用于显示 临时使用 （财务审核 基本页签查看）-->
<template>
  <div class="rate-grade">
    <el-input
      v-model="min"
      type="number"
    />
    <span>-</span>
    <el-input
      v-model="max"
      type="number"
    />
    <el-select
      v-show="showUnit"
      v-model="unit"
      clearable
    >
      <el-option
        v-for="(item,index) in gradeUnits"
        :key="index"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'

export default {
  name: 'RateGrade',
  props: {
    showUnit: { type: Boolean, default: false },
    gradeMin: { type: Number },
    gradeMax: { type: Number },
    gradeUnit: { type: String, default: '' }
  },
  data() {
    return {
      min: '',
      max: '',
      unit: '',
      gradeUnits: [
        {
          label: 'CBM',
          value: 'VOL'
        },
        {
          label: 'TON',
          value: 'WGT'
        },
        {
          label: 'RT',
          value: 'WGTX'
        }
      ]
    }
  },
  computed: {
  },
  watch: {
    min: function(newVal) {
      this.$emit('onChangeMin', (newVal === PriceConstant.NIL) ? 0 : parseFloat(newVal))
    },
    max: function(newVal) {
      this.$emit('onChangeMax', (newVal === PriceConstant.NIL) ? 0 : parseFloat(newVal))
    },
    unit: function(newVal) {
      const val = this.min === PriceConstant.NIL && this.max === PriceConstant.NIL ? '' : newVal
      this.$emit('onChangeUnit', val)
    }
  },
  mounted() {
    this.min = this.gradeMin === PriceConstant.NIL ? '' : this.gradeMin
    this.max = this.gradeMax === PriceConstant.NIL ? '' : this.gradeMax
    this.unit = this.gradeUnit
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  @import "~@/styles/element-variables.scss";
  .rate-grade{
    display: flex;
    .el-input {
      width: 100%;
      margin-right: 4px;
      text-align:right;
    }
  }
</style>
